var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 4,
    viewBox: "0 0 17 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41675 0C1.31675 0 0.416748 0.9 0.416748 2C0.416748 3.1 1.31675 4 2.41675 4C3.51675 4 4.41675 3.1 4.41675 2C4.41675 0.9 3.51675 0 2.41675 0ZM14.4167 0C13.3167 0 12.4167 0.9 12.4167 2C12.4167 3.1 13.3167 4 14.4167 4C15.5167 4 16.4167 3.1 16.4167 2C16.4167 0.9 15.5167 0 14.4167 0ZM8.41675 0C7.31675 0 6.41675 0.9 6.41675 2C6.41675 3.1 7.31675 4 8.41675 4C9.51675 4 10.4167 3.1 10.4167 2C10.4167 0.9 9.51675 0 8.41675 0Z",
    fill: "#42495E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableMenuIcon);
export default __webpack_public_path__ + "static/media/TableMenuIcon.8fc7bcaf.svg";
export { ForwardRef as ReactComponent };